export default Object.freeze({
    CORE_API_ACCESS_TOKEN_NAME: 'login-access-token',
});
